import { render, staticRenderFns } from "./editTableDialog.vue?vue&type=template&id=3df81092&scoped=true"
import script from "./editTableDialog.vue?vue&type=script&lang=js"
export * from "./editTableDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df81092",
  null
  
)

export default component.exports